import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'

import { getCreationState } from './state'
import { Text, Main } from '../../../components'
import { clearSessionSafe } from '../../../helpers/localStorage'
import { FormattedMessage } from 'react-intl'

type BaseFinishedProps = {
  error: { message: string }
  path: string
}
export function BaseFinished({ error, path }: BaseFinishedProps) {
  useEffect(() => {
    // Redirect to app if no error
    if (!error && path) {
      clearSessionSafe()
      window.location.href = path
    }
  }, [error, path])

  if (!error) {
    return null
  }

  return (
    <Main.Container>
      <Main.Title>
        <FormattedMessage
          id="boarding.createOrganization.error.title"
          defaultMessage="Something went wrong"
          values={{}}
        />
      </Main.Title>
      <Text.Corpus style={{ lineHeight: '1.8em' }}>
        <FormattedMessage
          id="boarding.createOrganization.error.description"
          defaultMessage="Please contact support about your issue {br} {error}"
          values={{
            br: <br />,
            error: error.message,
          }}
        />
      </Text.Corpus>
    </Main.Container>
  )
}

export function Finished() {
  const creationState = useSelector(getCreationState)
  const url = creationState.successRedirectPath
  const error = creationState?.creationError

  return <BaseFinished error={error} path={url} />
}
